import { Button, TextField } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { useGetProjectCounter, useSetProjectPointerCounter } from "../../interfaces/point";
import { MODAL_QUERY_NM } from "../../interfaces/modal";
import { useQueryClient } from "react-query";
import theme from "../../styles/theme";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const MainWrap = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding:0 0.5rem;
    .row {
        padding-top: 0.8rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 0.5rem;
        .left {
            width: 10rem;
            height: 100%;
            border-right: 1px solid ${theme.color.black[10]};
            padding: 0 0.5rem;
            li{
                text-align: center;
            }
        }
        .middle{
            height: 60%;
            display:flex;
            align-items: center;
        }
        .right {
            width: 100%;
            height: 100%;
            padding: 0 0.5rem;
            // border-left: 1px solid ${theme.color.black[10]};
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
    }
    ul {
        list-style-type: none;
        width: 100%;
        height: 100%;
        max-height: 100%;
        overflow: auto;
        padding: 0;
        margin: 0;
        cursor: pointer;
        li {
            font-size: 1rem;
            border-bottom: 1px solid ${theme.color.black[10]};
            padding: 0 0.5rem;
        }
        li:first-child{
            border-bottom: 2px solid ${theme.color.black[20]};
        }
        li:last-child{
            border:0;
        }
        .selected {
            background: ${theme.color.primary.pupple2};
        }
    }
    .counterList {
        padding-top: 1rem;
        li {
            display: grid;
            grid-template-columns: 3rem 2rem 6rem 5rem 5rem auto;
            gap: 1rem;
            align-items: center;
            padding: 0.5rem 0.5rem;
        }
        li:nth-child(n+2){
            span:first-child { text-align: center}
            span:nth-child(2){ text-align: center}
            span:last-child { text-align: left}
        }
    }
`;

const PointCounter = ({tid}) => {

    const queryClient = useQueryClient();

    const [dirCnt, setDirCnt] = useState();
    const [counterListExclude, setCounterListExclude] = useState();
    const [groupList, setGroupList] = useState([]);
    const [counterList, setCounterList] = useState([]);

    const [selectedDirNo, setSelectedDirNo] = useState([]);
    const [selectedGno, setSelectedGno] = useState();
    
    const [submitCnt, setSubmitCnt] = useState();

    const {data, refetch} = useGetProjectCounter(tid);

    const {mutate} = useSetProjectPointerCounter();

    const initState = () => {
        setDirCnt();
        setCounterListExclude();
        setGroupList([]);
        setCounterList([]);
        setSelectedDirNo([]);
        setSelectedGno();
    }

    useEffect(()=>{
        refetch();
        initState();
        setSubmitCnt();
    },[tid])

    useEffect(()=>{
        if(data && data.length>0){
            const tempCnt =  (submitCnt&&submitCnt>0)?submitCnt:data.length>0?data.map((item)=>item.dir_no).sort((a,b)=>a-b).reverse()[0]:0;
            const temp = Array.from(Array(tempCnt), (_, i) => i+1);
            const excl = temp.filter((item)=>data.findIndex((fItem)=>fItem.dir_no === item)<0);
            setCounterListExclude(excl);
            setDirCnt(tempCnt);
            const group =  data.map((dItem)=>({gno:dItem.gno,gnm:dItem.gnm})).filter((item,index,self)=>index===self.findIndex((t)=>(t.gno===item.gno && t.gnm===item.gnm)))
            setGroupList(group);
            setSelectedDirNo([]);
            handleGroupItemClick(selectedGno);
        }else{
            initState()
        }
    },[data])

    const handleInitClick = useCallback((tid) => {
        const temp = {
            mode: 'CLEAR',
            tid: tid,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg: '모두 삭제 하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleAutoClick = useCallback((tid,dir_cnt) => {
        const temp = {
            mode: 'AUTO',
            tid: tid,
            dir_cnt: dir_cnt
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg: '등록 하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleCounterAddClick = useCallback((tid,gno,counterArr,submitCnt) => {

        const tgnm = JSON.stringify(counterArr).replaceAll('[','').replaceAll(']','').replaceAll(',','-')
        const temp = {
            mode: 'POST_COUNTER',
            tid: tid,
            gnm: tgnm,
            gno: gno,
            counterArr: counterArr
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    setSubmitCnt(submitCnt);
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg: '등록 하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleCounterDelClick = useCallback((gno,dir_no) => {
        const temp = {
            mode: 'DEL_COUNTER',
            gno: gno,
            dir_no: dir_no
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg: '삭제 하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleDeleteClick = (updateItem) => {
        queryClient.setQueryData(
            [MODAL_QUERY_NM],
            {
                show:true,
                msg:'삭제하시겠습니까?',
                height:'20vh',
                okButton:()=>confirmDelete(updateItem)
            }
        )
    }

    const confirmDelete = useCallback((updateItem) => {
        const temp = {
            mode: 'DEL_GROUP',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'삭제하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleDirNoClick = (dirNo) => {
        const temp = selectedDirNo;
        const fIndex = temp.findIndex((item)=>item === dirNo);
        if(fIndex>-1){
            temp.splice(fIndex,1);
        }else{
            temp.push(dirNo);
        }
        temp.sort((a,b)=>a-b);
        setSelectedDirNo([...temp]);
    }

    const handleGroupItemClick = (gno) => {
        setSelectedGno(gno);
        if(data && gno){
            const temp = data.filter((item)=>item.gno===gno)
            setCounterList(temp);
        }
    }

    const handleGroupAddClick = () => {
        const temp = groupList.filter((fItem)=>fItem.gno === null).length+1;
        setGroupList([...groupList, {gno:null,gnm:'새그룹'+temp}])
    }

    const handleValueChange = (val) => {
        setDirCnt(parseInt(val,10));
    }
    
    const handleCreateClick = () => {
        setCounterListExclude(Array.from(Array(dirCnt), (_, i) => i+1));
    }

    return (
        <MainWrap>
            <div className="row">
                <TextField 
                    id='dir_cnt' 
                    label='방향수' 
                    size='small' 
                    InputLabelProps={{shrink:true}} 
                    value={dirCnt ? dirCnt : ''}
                    onChange={(e)=>handleValueChange(e.target.value)}
                />
                {}
                <Button variant='contained' onClick={handleCreateClick}>생성</Button>
                <Button variant='contained' onClick={()=>handleAutoClick(tid, dirCnt)}>자동생성</Button>
                <Button variant='contained' onClick={()=>handleInitClick(tid)}>초기화</Button>
            </div>
            <div className="row" style={{flexGrow:1,alignItems:'flex-start',gap:0}}>
                <div className='left' >
                    <div style={{minHeight:'calc(40% + 1rem)'}}>
                        <ul>
                            <li>
                                방향번호
                            </li>
                            {
                                counterListExclude && counterListExclude.map((item)=> <li className={(selectedDirNo.findIndex((fItem)=>fItem===item) > -1) ? 'selected':''} onClick={()=>handleDirNoClick(item)}>{item}</li>)
                            }
                        </ul>
                    </div>
                    <Button 
                        variant="contained" 
                        style={{width:'100%'}} 
                        onClick={()=>handleCounterAddClick(tid,selectedGno,selectedDirNo,dirCnt)}>
                            <ArrowForwardIcon />
                    </Button>
                </div>
                {/* <div className="middle">
                    <div></div>
                </div> */}
                <div className='right' style={{width:'100%'}}>
                    <div style={{height: '40%'}}>
                        <ul>
                            <li>그룹</li>
                            {
                                groupList && groupList.map((item)=><li className={selectedGno === item.gno ? 'selected':''} onClick={()=>handleGroupItemClick(item.gno)}>{item.gnm}</li>)
                            }
                        </ul>
                    </div>
                    <div className="row">
                        <Button variant='contained' style={{width:'100%'}} onClick={handleGroupAddClick}>새그룹</Button>
                        <Button variant='contained' style={{width:'100%'}} onClick={()=>handleDeleteClick({tid:tid,gno:selectedGno})}>선택그룹삭제</Button>
                    </div>
                    <div style={{borderTop: '1px solid '+theme.color.black[10] }}>
                        <ul className="counterList">
                            <li>
                                <span>카운터</span>
                                <span>번호</span>
                                <span>표시명</span>
                            </li>
                            {
                                counterList && counterList.map((item)=>(
                                    <li>
                                        <span>{item.cnt_nm}</span>
                                        <span>{item.dir_no}</span>
                                        <CounterItem item={item} />
                                        <div><Button variant='contained' style={{width:'100%'}}  onClick={()=>handleCounterDelClick(item.gno, item.dir_no)}>삭제</Button></div>
                                    </li>
                                    ))
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </MainWrap>
    )

}

const CounterItem = ({item}) => {

    const queryClient = useQueryClient();

    const [target,setTarget] = useState();

    const {mutate} = useSetProjectPointerCounter();

    useEffect(()=>{
        setTarget(item)
    },[item])

    const handleCounterModClick = useCallback((updateItem) => {
        const temp = {
            mode: 'MOD_COUNTER',
            ...updateItem
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg: '수정 하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleValueChange = (id,val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    return (
        <React.Fragment>
            <div>
                <TextField
                id='dir_nm'
                label='표시명'
                size="small"
                style={{width:'100%'}} 
                value={target && target.dir_nm}
                InputLabelProps={{shrink:true}}
                onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
            />
            </div>
            <div>
                <Button variant='contained' style={{width:'100%'}} onClick={()=>handleCounterModClick(target)}>수정</Button>
            </div>
        </React.Fragment>
        
    )
}

export default PointCounter;